/**
 * Professional Translation Dictionary for Testamentair.com
 * Tone: Premium, Strategic, Discreet (Private Wealth Advisory style)
 */
export const translations = {
  nl: {
    nav: {
      howItWorks: 'Hoe het werkt',
      situations: 'Situaties',
      international: 'Internationaal',
      knowledge: 'Kennisbank',
      faq: 'FAQ',
      startScan: 'Start scan'
    },
    footer: {
      desc: 'De intelligente voorbereidingslaag voor uw nalatenschap. Zonder jargon, met volledige helderheid voordat u naar de notaris gaat.',
      platform: 'Platform',
      knowledge: 'Kennis',
      company: 'Bedrijf',
      rights: 'Alle rechten voorbehouden.',
      contact: 'Contact',
      legalNote: 'Testamentair biedt geen juridisch of notarieel advies.',
      privacy: 'Privacy & Security',
      cookies: 'Cookiebeleid',
      terms: 'Algemene Voorwaarden',
      disclaimer: 'Disclaimer'
    },
    contact: {
      title: 'Contact',
      intro: 'Heb je vragen over Testamentair of weet je niet goed waar je moet beginnen? Stuur gerust een bericht. We reageren meestal binnen 24 uur.',
      emailTitle: 'Email',
      emailDesc: 'Voor vragen over het platform of voor algemene ondersteuning.',
      formTitle: 'Stuur een bericht',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      email: 'Email',
      message: 'Bericht',
      button: 'Verstuur bericht',
      submitting: 'Versturen...',
      success: 'Bedankt voor je bericht. We reageren meestal binnen 24 uur.',
      error: 'Er ging iets mis bij het verzenden. Probeer het later opnieuw.',
      rateLimit: 'Je hebt onlangs al een bericht gestuurd. Wacht even voordat je opnieuw verzendt.',
      disclaimer: 'Testamentair biedt geen juridisch of notarieel advies.'
    },
    hero: {
      badge: 'Uw nalatenschap goed voorbereid',
      title: 'Regel uw nalatenschap slim, nog voordat u naar de notaris gaat.',
      subtitle: 'Voorkom onnodige erfbelasting, onduidelijkheid binnen de familie en juridische valkuilen. Doe de gratis scan en ontvang binnen 3 minuten een strategisch dossier dat precies aangeeft wat uw situatie vereist.',
      ctaPrimary: 'Start gratis scan',
      ctaSecondary: 'Hoe werkt het?',
      footer: 'Voor ondernemers, expats en moderne familieconstructies'
    },
    trust: [
      'Gratis basis scan',
      'Goed voorbereid naar de notaris',
      'Discreet en veilig verwerkt',
      'Ook voor internationale situaties'
    ],
    preview: {
      title: 'Bekijk wat u ontvangt',
      desc: 'Na de gratis scan ontvangt u een strategisch dossier met uw belangrijkste risico’s, fiscale aandachtspunten en aanbevolen vervolgstappen.',
      points: [
        'Risicoscore en kwetsbaarheden',
        'Fiscale aandachtspunten en kansen',
        'Concrete vervolgstappen richting notaris'
      ],
      footer: 'Helder en discreet, als voorbereiding op het gesprek met uw notaris.'
    },
    steps: {
      title: 'In 3 stappen naar volledige helderheid',
      subtitle: 'Wij vertalen complexe wetgeving naar een helder persoonlijk plan.',
      items: [
        {
          num: "01",
          title: "De Intelligente Intake",
          desc: "Via een rustige, chat-achtige interface stellen we je gericht vragen. Geen eindeloze formulieren vol juridisch jargon.",
          icon: "MessageCircle"
        },
        {
          num: "02",
          title: "AI-Gedreven Analyse",
          desc: "Onze technologie analyseert je antwoorden direct. We identificeren fiscale kansen en risico's omtrent internationaal recht.",
          icon: "Cpu"
        },
        {
          num: "03",
          title: "Het Notaris-Klaar Rapport",
          desc: "Je ontvangt een helder, gestructureerd overzicht. Hiermee ga je goed voorbereid naar een notaris naar keuze.",
          icon: "FileCheck"
        }
      ]
    },
    cta: {
      title: 'Krijg vandaag helder inzicht',
      desc: 'Start de gratis scan en ontdek binnen enkele minuten welke stappen passen bij uw situatie.',
      button: 'Start de gratis scan',
      security: 'DISCREET EN VERTROUWELIJK'
    },
    international: {
      badge: 'Grensoverschrijdende Expertise',
      title: 'Internationaal Erfrecht & Nalatenschap',
      desc: 'Wonen in het buitenland, een tweede woning aan de kust of een internationale vermogensstructuur? Grensoverschrijdende nalatenschappen zijn complex en vereisen gespecialiseerde voorbereiding.',
      features: [
        {
          title: 'EU Erfrechtverordening',
          desc: 'Bepaal welk recht van toepassing is op uw nalatenschap om ongewenste lokale wetgeving te voorkomen.',
          icon: 'Shield'
        },
        {
          title: 'Buitenlands Vastgoed',
          desc: 'Specifieke regels voor bezittingen in landen als Spanje of Frankrijk vereisen een strategische structuur.',
          icon: 'Home'
        },
        {
          title: 'Vermogensbescherming',
          desc: 'Voorkom dat er in zowel Nederland als het buitenland successierechten worden geheven over dezelfde bezittingen.',
          icon: 'TrendingUp'
        }
      ],
      cta: 'Start internationale audit'
    },
    knowledge: {
      title: 'Kennisbank',
      subtitle: 'Heldere antwoorden op complexe vragen. Geen juridisch jargon, gewoon begrijpelijke taal.',
      search: 'Zoek artikelen of onderwerpen...',
      readTime: 'min leesgraad',
      articles: [
        { cat: 'Erfbelasting', title: 'Hoe voorkom je dat de fiscus meegeniet?', time: '5' },
        { cat: 'Testament', title: 'De 5 grootste misverstanden over het testament', time: '4' },
        { cat: 'Executeur', title: 'Wie wijs je aan om je zaken af te handelen?', time: '6' },
        { cat: 'Internationaal', title: 'Een huis in Spanje: wat gebeurt er bij overlijden?', time: '7' },
        { cat: 'Ondernemen', title: 'Bedrijfsopvolging en de erfbelasting (BOR)', time: '8' },
        { cat: 'Crypto', title: 'Zorg dat je Bitcoin niet voor altijd verdwijnt', time: '4' }
      ]
    },
    faq: {
      title: 'Veelgestelde vragen',
      subtitle: 'Alles wat je moet weten over Testamentair.com.',
      items: [
        {
          q: "Is een notaris nog steeds nodig?",
          a: "Ja. Testamentair.com vervangt de notaris niet. Wij zorgen ervoor dat je perfect voorbereid naar de notaris gaat, waardoor het proces daar veel sneller en vaak goedkoper verloopt."
        },
        {
          q: "Is dit juridisch geldig?",
          a: "Onze analyses en rapporten zijn puur ter voorbereiding en informatie. De daadwerkelijke, juridisch bindende akte wordt altijd gepasseerd door een beëdigd notaris."
        },
        {
          q: "Wat kost het?",
          a: "De basis scan en het overzichtelijke rapport zijn volledig gratis. Voor complexe internationale of zakelijke analyses bieden we premium checks aan."
        },
        {
          q: "Hoe veilig is mijn data?",
          a: "Extreem veilig. We gebruiken bank-grade encryptie en delen je gegevens nooit met derden zonder jouw expliciete toestemming."
        },
        {
          q: "Werkt dit ook voor expats?",
          a: "Zeker. We hebben een gespecialiseerde module voor internationale situaties, waaronder de EU Erfrechtverordening en bezittingen in het buitenland."
        }
      ]
    },
    howItWorks: {
      title: 'Hoe het werkt',
      subtitle: 'De brug tussen jouw wensen en de officiële vastlegging. Simpel, transparant en volledig afgestemd op de moderne complexiteit.',
      steps: [
        {
          num: "01",
          title: "De Intelligente Intake",
          desc: "Via een rustige, chat-achtige interface stellen we je gericht vragen. Geen eindeloze formulieren vol juridisch jargon.",
          icon: "MessageCircle"
        },
        {
          num: "02",
          title: "AI-Gedreven Analyse",
          desc: "Onze technologie analyseert je antwoorden direct. We identificeren fiscale kansen en risico's omtrent internationaal recht.",
          icon: "Cpu"
        },
        {
          num: "03",
          title: "Het Notaris-Klaar Rapport",
          desc: "Je ontvangt een helder, gestructureerd overzicht. Hiermee ga je goed voorbereid naar een notaris naar keuze.",
          icon: "FileCheck"
        }
      ]
    },
    situations: {
      title: 'Specifieke Situaties',
      subtitle: 'Ieder leven is uniek. Standaard wettelijke regels sluiten zelden perfect aan bij moderne levensstijlen.',
      items: {
        blended: {
          title: 'Samengesteld gezin',
          desc: 'Bescherm je nieuwe partner zonder je eigen kinderen te benadelen.'
        },
        entrepreneur: {
          title: 'Ondernemer',
          desc: 'Zorg voor bedrijfscontinuïteit en voorkom dat de fiscus de grootste erfgenaam wordt.'
        },
        international: {
          title: 'Expats & Internationaal',
          desc: 'Navigeer door complexe internationale erfrechtregels en vermijd dubbele belasting.'
        },
        unmarried: {
          title: 'Ongehuwd samenwonen',
          desc: 'Zonder testament erft je partner niets. Regel het goed.'
        },
        digital: {
          title: 'Crypto & Digitaal',
          desc: 'Zorg dat je digitale vermogen toegankelijk blijft voor je nabestaanden.'
        },
        single: {
          title: 'Alleenstaand',
          desc: 'Bepaal zelf wie jouw vermogen erft.'
        }
      }
    },
    tools: {
      title: 'Tools & Calculators',
      subtitle: 'Krijg direct inzicht met onze interactieve tools.',
      check: {
        title: 'Testament Check',
        desc: 'Is uw huidige testament nog up-to-date?',
        cta: 'Open tool'
      },
      tax: {
        title: 'Erfbelasting Analyse',
        desc: 'Inzicht in de fiscale gevolgen.',
        cta: 'Open tool'
      },
      executor: {
        title: 'Executeur Checklist',
        desc: 'Persoonlijk stappenplan na overlijden.',
        cta: 'Download'
      }
    },
    scanResult: {
      scoreTitle: 'Uw Score',
      scoreSubtitle: 'Op basis van uw profiel hebben we een risico-inschatting gemaakt.',
      complexity: 'Complexiteit & Risico',
      findings: 'Vaststellingen',
      risk: 'Grootste Risico',
      optimization: 'Optimalisatie',
      premiumTitle: 'Ontvang het Strategisch Dossier',
      premiumDesc: 'Toegang tot de volledige analyse en notaris-checklist.',
      unlocked: 'Vrijgegeven',
      downloadCta: 'Download Dossier',
      investment: 'Eenmalige investering',
      unlockTest: 'Test-modus'
    }
  },
  en: {
    nav: {
      howItWorks: 'How it works',
      situations: 'Situations',
      international: 'International',
      knowledge: 'Insights',
      faq: 'FAQ',
      startScan: 'Start scan'
    },
    footer: {
      desc: 'The intelligent preparation layer for your estate. No jargon, with full clarity before you meet the notary.',
      platform: 'Platform',
      knowledge: 'Insights',
      company: 'Company',
      rights: 'All rights reserved.',
      contact: 'Contact',
      legalNote: 'Testamentair does not provide legal or notarial advice.',
      privacy: 'Privacy & Security',
      cookies: 'Cookie Policy',
      terms: 'Terms & Conditions',
      disclaimer: 'Disclaimer'
    },
    contact: {
      title: 'Contact',
      intro: 'Do you have questions about Testamentair or aren\'t sure where to start? Feel free to send a message. We typically respond within 24 hours.',
      emailTitle: 'Email',
      emailDesc: 'For questions about the platform or general support.',
      formTitle: 'Send a message',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      message: 'Message',
      button: 'Send message',
      submitting: 'Sending...',
      success: 'Thank you for your message. We typically respond within 24 hours.',
      error: 'Something went wrong while sending. Please try again later.',
      rateLimit: 'You have recently sent a message. Please wait a moment before sending again.',
      disclaimer: 'Testamentair does not provide legal or notarial advice.'
    },
    hero: {
      badge: 'Strategic inheritance preparation',
      title: 'Structure your inheritance strategy before meeting the notary.',
      subtitle: 'Optimize for tax efficiency, prevent family disputes, and navigate legal complexities. Complete our 3-minute assessment to receive a strategic dossier tailored to your unique wealth structure.',
      ctaPrimary: 'Start free assessment',
      ctaSecondary: 'How it works',
      footer: 'For entrepreneurs, expats, and complex family dynamics'
    },
    trust: [
      'Free basic assessment',
      'Expertly prepared for the notary',
      'Discreet & secure processing',
      'Global heritage expertise'
    ],
    preview: {
      title: 'See what you receive',
      desc: 'Upon completion, you will receive a strategic dossier outlining your primary risks, tax optimization opportunities, and recommended legal steps.',
      points: [
        'Risk assessment & vulnerabilities',
        'Tax efficiency opportunities',
        'Actionable roadmap for your notary'
      ],
      footer: 'Clear and confidential preparation for your legal consultation.'
    },
    steps: {
      title: 'Clarity in three simple steps',
      subtitle: 'Translating complex legal frameworks into a clear personal strategy.',
      items: [
        {
          num: "01",
          title: "Intelligent Intake",
          desc: "Through a calm, intuitive interface, we guide you through essential questions. No endless forms or legal jargon.",
          icon: "MessageCircle"
        },
        {
          num: "02",
          title: "Strategic Analysis",
          desc: "Our technology analyzes your profile instantly, identifying tax opportunities and cross-border legal risks.",
          icon: "Cpu"
        },
        {
          num: "03",
          title: "Notary-Ready Dossier",
          desc: "Receive a structured, professional overview to streamline your consultation with any legal professional.",
          icon: "FileCheck"
        }
      ]
    },
    cta: {
      title: 'Gain clarity on your legacy today',
      desc: 'Start the free assessment and discover within minutes the strategic steps required for your situation.',
      button: 'Start free assessment',
      security: 'DISCREET & CONFIDENTIAL'
    },
    international: {
      badge: 'Cross-Border Expertise',
      title: 'International Estate Planning & Inheritance',
      desc: 'Residing abroad, owning overseas property, or managing an international wealth structure? Cross-border estates are complex and require specialized strategic preparation.',
      features: [
        {
          title: 'EU Succession Regulation',
          desc: 'Determine which jurisdiction applies to your estate to prevent unwanted local legal interference.',
          icon: 'Shield'
        },
        {
          title: 'Foreign Real Estate',
          desc: 'Specific regulations for assets in countries like Spain or France require a bespoke strategic structure.',
          icon: 'Home'
        },
        {
          title: 'Wealth Preservation',
          desc: 'Navigate international tax treaties to prevent double taxation on your global assets.',
          icon: 'TrendingUp'
        }
      ],
      cta: 'Start international audit'
    },
    knowledge: {
      title: 'Insights',
      subtitle: 'Strategic answers to complex questions. Clear, actionable intelligence for your estate planning.',
      search: 'Search articles or topics...',
      readTime: 'min read',
      articles: [
        { cat: 'Tax Optimization', title: 'How to minimize the tax impact on your legacy', time: '5' },
        { cat: 'Estate Planning', title: 'The 5 most common myths about wills', time: '4' },
        { cat: 'Administration', title: 'Choosing the right representative for your estate', time: '6' },
        { cat: 'Cross-Border', title: 'Property abroad: Navigating cross-border succession', time: '7' },
        { cat: 'Business', title: 'Business continuity and succession tax strategies', time: '8' },
        { cat: 'Digital Assets', title: 'Securing your digital wealth and crypto legacy', time: '4' }
      ]
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know about preparing your estate with Testamentair.',
      items: [
        {
          q: "Is a notary still required?",
          a: "Yes. Testamentair.com does not replace the notary. We ensure you are perfectly prepared for your consultation, making the legal process more efficient and cost-effective."
        },
        {
          q: "Is this legally binding?",
          a: "Our analyses and dossiers are strictly for preparation and information. The formal, legally binding deed must always be executed by a licensed notary."
        },
        {
          q: "What are the costs?",
          a: "The basic assessment and initial report are free of charge. We offer premium modules for complex international or corporate wealth structures."
        },
        {
          q: "Is my data secure?",
          a: "We utilize bank-grade encryption and never share your confidential information with third parties without your explicit consent."
        },
        {
          q: "Does it work for expats?",
          a: "Absolutely. We have specialized modules for international situations, covering the EU Succession Regulation and cross-border asset management."
        }
      ]
    },
    howItWorks: {
      title: 'How it works',
      subtitle: 'The bridge between your objectives and legal formalization. Simple, transparent, and fully aligned with modern complexities.',
      steps: [
        {
          num: "01",
          title: "Intelligent Intake",
          desc: "Through a calm, intuitive interface, we guide you through essential questions. No endless forms or legal jargon.",
          icon: "MessageCircle"
        },
        {
          num: "02",
          title: "Strategic Analysis",
          desc: "Our technology analyzes your profile instantly, identifying tax opportunities and cross-border legal risks.",
          icon: "Cpu"
        },
        {
          num: "03",
          title: "Notary-Ready Dossier",
          desc: "Receive a structured, professional overview to streamline your consultation with any legal professional.",
          icon: "FileCheck"
        }
      ]
    },
    situations: {
      title: 'Strategic Situations',
      subtitle: 'Every life is unique. Standard legal frameworks rarely align perfectly with modern family dynamics.',
      items: {
        blended: {
          title: 'Blended family',
          desc: 'Protect your partner without disadvantaging your own children.'
        },
        entrepreneur: {
          title: 'Entrepreneur',
          desc: 'Ensure business continuity and prevent excessive taxation on your life’s work.'
        },
        international: {
          title: 'Expats & International',
          desc: 'Navigate complex cross-border inheritance rules and avoid double taxation.'
        },
        unmarried: {
          title: 'Unmarried partners',
          desc: 'Without a will, your partner may have no legal standing.'
        },
        digital: {
          title: 'Digital Assets',
          desc: 'Ensure your digital wealth and crypto remain accessible to your heirs.'
        },
        single: {
          title: 'Single individuals',
          desc: 'Take control of your legacy.'
        }
      }
    },
    tools: {
      title: 'Tools & Calculators',
      subtitle: 'Gain immediate strategic insights through our interactive tools.',
      check: {
        title: 'Will & Estate Review',
        desc: 'Is your current estate plan still up-to-date?',
        cta: 'Open tool'
      },
      tax: {
        title: 'Inheritance Tax Analysis',
        desc: 'Instant clarity on fiscal impact.',
        cta: 'Open tool'
      },
      executor: {
        title: 'Executor Checklist',
        desc: 'Personalized roadmap after bereavement.',
        cta: 'Download'
      }
    },
    scanResult: {
      scoreTitle: 'Your Analysis',
      scoreSubtitle: 'Based on your profile, we have conducted an initial risk assessment.',
      complexity: 'Complexity & Risk',
      findings: 'Strategic Findings',
      risk: 'Primary Risk',
      optimization: 'Optimization',
      premiumTitle: 'Access the Strategic Dossier',
      premiumDesc: 'Gain access to the full analysis and notary roadmap.',
      unlocked: 'Released',
      downloadCta: 'Download Dossier',
      investment: 'One-time investment',
      unlockTest: 'Test Mode'
    }
  }
};